import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import BlockableRow from '../BlockableRow';

const IS_ACTIVE_KEY = 'trigger.rules.MobileOsVersion.isActive';

const StyledElement = styled.div`
  input {
    width: 300px;
  }
`;

const TargetByOSVersion = () => (
  <BlockableRow title="OS version" isActiveFieldName={IS_ACTIVE_KEY}>
    <StyledElement>
      <Field name="trigger.rules.MobileOsVersion.params.versions" component="input" />
    </StyledElement>
  </BlockableRow>
);

export default TargetByOSVersion;
